import { CourseUserViewModel } from "../coursesApiSlice";
import CourseUsersTable from "./CourseUsersTable";

interface CourseStudentsProps {
	students: CourseUserViewModel[];
	courseId: number;
	schoolId: number;
	districtId: number;
	seatsRemaining: number;
	showSeatsWarning: boolean;
	setErrorMessage: (message: string) => void;
}

export default function CourseStudentsSection(props: CourseStudentsProps) {
	return (
		<section>
			<hr className="my-6" />
			<h2>Students</h2>
			<CourseUsersTable
				users={props.students}
				courseId={props.courseId}
				schoolId={props.schoolId}
				districtId={props.districtId}
				displayLength={10}
				isTeacherTable={false}
				seatsRemaining={props.seatsRemaining}
				showSeatsWarning={props.showSeatsWarning}
				setErrorMessage={props.setErrorMessage}
			/>
		</section>
	);
}
